import React from "react";
import PropTypes from "prop-types";

const CheckComponent = ({ title, id, checked, onChange }) => (
  <label
    className={`tw-flex tw-min-h-16 tw-w-full tw-cursor-pointer tw-items-center tw-gap-3 tw-rounded-dis-card tw-border-2 tw-border-solid tw-p-4 tw-transition-colors tw-duration-200 focus-within:tw-outline-2 focus-within:tw-outline-dis-deep-blue focus-within:tw-outline-offset-2 ${
      checked
        ? "tw-border-dis-deep-blue tw-bg-dis-sky-tint"
        : "tw-border-dis-border-strong tw-bg-white hover:tw-border-dis-deep-blue"
    }`}
    htmlFor={id}
  >
    <input
      type="checkbox"
      id={id}
      checked={checked}
      onChange={onChange}
      className="tw-landing-native-checkbox tw-m-0 tw-h-5 tw-w-5 tw-min-w-5 tw-shrink-0 tw-cursor-pointer tw-accent-dis-deep-blue"
    />
    <span className="tw-m-0 tw-text-base tw-font-semibold tw-text-dis-navy">
      {title}
    </span>
  </label>
);

CheckComponent.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CheckComponent;
